import React from 'react';
import '../styles/LiquidButton.css'

const LiquidButton = ({ 
  children, 
  className = '', 
  onClick, 
  disabled = false,
  type = 'button',
  ...props 
}) => {
  const baseClasses = 'LiqButtBg';
  const combinedClasses = `${baseClasses} ${className}`.trim();

  return (
    <div className="LiqButtCont">
        <button
            type={type}
            className={combinedClasses}
            onClick={onClick}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    </div>
  );
};

export default LiquidButton;